"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Options_1 = __importDefault(require("../Options"));
const connector_1 = require("@datenbanker/connector");
const User = {
    get: (condition, projection, limit) => {
        return (0, connector_1.createGET)(Options_1.default.buildPath("/user"), Options_1.default.getApiKey())(condition, projection, limit);
    },
    add: (data) => {
        return (0, connector_1.createPOST)(Options_1.default.buildPath("/user"), Options_1.default.getApiKey())(data);
    },
};
exports.default = User;
